import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { FileHelpers } from '@questelservices/common-vue';
import { FileAuthorizationRequest } from '@questelservices/common-vue/dist/models/FileAuthorization';


export class FileService {
  private readonly client: QuestelServicesClient;
  private readonly fileService: FileHelpers;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/files');
    this.fileService = new FileHelpers(store);
    
  }
  
  async uploadFiles(request: FileAuthorizationRequest, selectedFiles: any): Promise<any> {
    return this.fileService.getUploadAuthorization('/api/files/upload/authorization',request)
            .then(async (result: any)=>{
                let formData = new FormData();
                formData.append('files[]', selectedFiles);

                let res = await this.client.upload(result.Url, formData, result.Token);
                return res;
            }).catch((error : any)=>{
                return JSON.parse(error);
            });
  }

  async downloadFiles(fileIds: Guid[]): Promise<any> {
    return this.client.getPostData(`/download`, fileIds)
      .then(async (result : any) => {
        let res = await this.client.download(result.Url, result.Token);
        
        return res;
      })
      .catch((err : any) => JSON.parse(err));
  }
  
}
